// Load the audio file
const notificationSound = new Audio("/assets/audio/notification2.mp3");

// Play the sound
export const playNotificationSound = () => {
  notificationSound.currentTime = 0; // Reset to the start
  notificationSound.play().catch((err) => {
    console.error("Failed to play sound:", err);
  });
};